
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormContainer } from "../../Components/FormContainer.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../Components/Input.js";
import { Msg } from "./Types.js";
import { map, defaultArgWith, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { NewReceiverCustomProperties } from "../../Widgets/CustomProperties.js";
import { PropertyConfigurationVisibility } from "../../Shared/PropertyConfiguration.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEdit, update as update_1, initNew } from "./State.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { getQueryParams } from "../../Common.js";
import { singleton as singleton_1, append as append_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function SchoolClassForm(props) {
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, {
        Children: toList(delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("general.name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(0, [arg]));
            },
            TestId: "school-class-name",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.SchoolClass.Name,
        })), delay(() => append(singleton(createElement(Input, {
            ComponentState: componentState,
            Label: t("general.description"),
            OnChange: (arg_1) => {
                props.Dispatch(new Msg(1, [arg_1]));
            },
            TestId: "school-class-description",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "description")),
            Value: props.SchoolClass.Description,
        })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(createElement(BusinessUnitSelect, {
            BusinessUnits: props.BusinessUnits,
            FormState: props.FormState,
            OnChange: (value) => {
                props.Dispatch(new Msg(4, [value]));
            },
            SelectedBusinessUnitId: unwrap(props.SchoolClass.BusinessUnitId),
        })) : empty()) : empty(), delay(() => {
            let Label_2, Value_2;
            return append(isFeatureEnabled(new Feature(15, [])) ? singleton(createElement(Input, (Label_2 = t("general.email"), (Value_2 = defaultArg(props.SchoolClass.Email, ""), {
                ComponentState: componentState,
                Label: unwrap(Label_2),
                OnChange: (arg_2) => {
                    props.Dispatch(new Msg(2, [arg_2]));
                },
                TestId: "school-class-email",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "email")),
                Value: Value_2,
            })))) : empty(), delay(() => (props.IsCustomPropertiesEnabled ? singleton(createElement(NewReceiverCustomProperties, {
                Currency: props.CustomerConfiguration.Currency,
                CustomProperties: props.SchoolClass.CustomProperties,
                FormState: props.FormState,
                OnSetCustomProperty: (arg_3) => {
                    props.Dispatch(new Msg(3, [arg_3]));
                },
                PropertyConfigurationType: new PropertyConfigurationVisibility(11, []),
                PropertyConfigurations: props.PropertyConfigurations,
            })) : empty())));
        })))))))),
        FormState: props.FormState,
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewSchoolClassView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNew, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.IsCustomPropertiesEnabled;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.AccountSettings;
    const matchValue_4 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, propertyConfigurations, schoolClass;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_3.fields[0];
        businessUnits = matchValue_4.fields[0];
        isCustomPropertiesEnabled = matchValue_1.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        schoolClass = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(SchoolClassForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("school_class.create_new_school_class"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                OnBack: () => {
                    RouterModule_nav(ofArray(["receivers", "school-classes" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(5, []));
                },
                PropertyConfigurations: propertyConfigurations,
                SchoolClass: schoolClass,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function EditSchoolClassView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEdit, update_1, (_arg, _arg_1) => {
    }), props.SchoolClassId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.IsCustomPropertiesEnabled;
    const matchValue_2 = state_1.PropertyConfigurations;
    const matchValue_3 = state_1.AccountSettings;
    const matchValue_4 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, propertyConfigurations, schoolClass;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_3.fields[0];
        businessUnits = matchValue_4.fields[0];
        isCustomPropertiesEnabled = matchValue_1.fields[0];
        propertyConfigurations = matchValue_2.fields[0];
        schoolClass = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(SchoolClassForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("school_class.edit_school_class"),
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled,
                OnBack: () => {
                    const xs = ofArray(props.OnBackPath);
                    const queryString = getQueryParams(undefined);
                    defaultArgWith(map((tupledArg) => {
                        RouterModule_nav(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 1, 1);
                    }, RouterModule_trySeparateLast(xs)), () => {
                        RouterModule_nav(singleton_1(RouterModule_encodeQueryString(queryString)), 1, 1);
                    });
                },
                OnSave: () => {
                    dispatch(new Msg(6, []));
                },
                PropertyConfigurations: propertyConfigurations,
                SchoolClass: schoolClass,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

